import React from 'react';
import PropTypes from 'prop-types';
import { ExamplesPresenter } from '../../ExamplesPresenter/ExamplesPresenter';
import { EXAMPLE_TYPES } from '../../../../types';

export const ObjectExample = ({ example, name }) => (
  <ExamplesPresenter
    displayName={name}
    renderFor={EXAMPLE_TYPES.OBJECT}
    example={example}
  />
);

ObjectExample.propTypes = {
  example: PropTypes.any,
  name: PropTypes.string,
};
